import { IMG_CDN_URL } from "../constants";
import { useDispatch, useSelector } from "react-redux";
import { addItem } from "../utils/cartSlice";

const MenuItem = ({ item }) => {

  const cartItems = useSelector((store) => store.cart.items);
  const itemQuantityReq =
    cartItems.find((cartItem) => cartItem.id === item.id)?.quantity || 0;

  const dispatch = useDispatch();

  const addItemHandler = (inc) => {
    dispatch(addItem({ ...item, quantity: (itemQuantityReq + inc) }));
  };

  return (
    <article className="grid grid-cols-4 sm:grid-cols-5 my-4 shadow-md shadow-cyan-100 rounded-md py-1">
      <div className="col-span-3 sm:col-span-4 p-2">
        <div className="item-attributes">
          <span
            className="veg-or-nonveg"
            style={{
              color:
                item?.itemAttribute?.vegClassifier === "VEG"
                  ? "green"
                  : "#EE204E",
            }}
          >
            &#9689;
          </span>
          {item?.isBestseller && (
            <span className="text-cyan-500 font-semibold text-sm">
              &#9733;Bestseller
            </span>
          )}
        </div>
        <h4 className="text-sm sm:text-base font-semibold text-slate-800">
          {item?.name}
        </h4>
        <h5 className="text-sm font-semibold text-slate-900 my-1">
          <span>&#8377;</span>
          {item?.price / 100 || item?.defaultPrice / 100}
        </h5>
        <p className="text-xs lg:text-sm  text-slate-600">
          {item?.description}
        </p>
      </div>

      <div className="relative p-0 sm:p-2 flex flex-col items-center justify-center">
        <figure className="relative w-full h-20 sm:h-32 overflow-hidden rounded-md">
          {item?.imageId && (
            <img
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full max-h-none"
              src={IMG_CDN_URL + item.imageId}
            />
          )}
        </figure>

        <div className="absolute bottom-0 z-50 bg-white flex text-cyan-500 shadow-md rounded-md text-sm sm:text-base font-medium w-full sm:w-2/3 mx-auto my-2 py-1">
          {itemQuantityReq === 0 ? (
            <button
              data-testid="add-btn"
              className="w-full"
              onClick={() => addItemHandler(1)}
            >
              Add
            </button>
          ) : (
            <>
              <button
                data-testid="dec-btn"
                className="w-1/3"
                onClick={() => addItemHandler(-1)}
              >
                -
              </button>
              <span className="text-center w-1/3">{itemQuantityReq}</span>
              <button className="w-1/3" onClick={() => addItemHandler(1)}>
                +
              </button>
            </>
          )}
        </div>
      </div>
    </article>
  );
};

export default MenuItem;
